/** The agent page's tabs: the route validates ?tab= against them (router.tsx), the page shows them (AgentPage). */
export const AGENT_TABS = ["build", "versions", "evals", "experiments", "copilot"] as const;
export type AgentTab = (typeof AGENT_TABS)[number];
